import Content from './Content'

const ApplicationPage = () => {
  return (
    <div>
      <Content />
    </div>
  )
}

export default ApplicationPage